import React, { FC } from 'react'
import LocationGroupsItem from './components/LocationGroups/LocationGroupsItem'
import { useWorkingHoursGroupsT } from './hooks/useWorkingHoursLocationGroups'

type PropsT = {
  workingHoursGroupsHook: useWorkingHoursGroupsT
}

const LocationWorkingHours: FC<React.PropsWithChildren<PropsT>> = ({
  workingHoursGroupsHook: { locationWorkingHoursGroups, ...hookRest },
}) => (
  <>
    <div>
      <div className="font-medium text-16px mb-3">Working hours by location</div>
      <div className="text-sm text-grey-700 mb-2">
        Create a group of locations, then customize working hours for the group.
      </div>

      {locationWorkingHoursGroups.map((group) => (
        <LocationGroupsItem
          key={group.key}
          locationWorkingHoursGroup={group}
          workingHoursGroupsHook={hookRest}
        />
      ))}
    </div>
  </>
)
export default LocationWorkingHours
